module.exports = __webpack_public_path__ + "static/media/flags.61313cb9.png";


//////////////////
// WEBPACK FOOTER
// ./~/report-components/src/modules/viewer/flags/flags.png
// module id = 309
// module chunks = 4